import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, md } from 'vuetify/iconsets/md'
import 'vuetify/styles'

export default createVuetify({
	components,
	directives,
	icons: {
		defaultSet: 'md',
		aliases,
		sets: { md },
	},
	theme: {
		defaultTheme: 'light',
		themes: {
			light: {
				dark: false,
				colors: {
					primary: '#4f0077',
					secondary: '#30302f',
					accent: '#621573',
					warning: '#f38901',
					success: '#84a919',
					info: '#2abad9',
				},
			},
			dark: {
				dark: true,
				colors: {
					primary: '#4f0077',
					secondary: '#30302f',
					accent: '#621573',
					warning: '#f38901',
					success: '#84a919',
					info: '#2abad9',
				},
			},
		},
	},
})
